import { NavLink } from 'react-router-dom';

import SvgIcon from '../SvgIcon/SvgIcon';

import Logo from '../../images/logo/logo.svg';
import LogoIcon from '../../images/logo/logo-icon.svg';

interface SidebarHeaderV2Props {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;

  compactMode?: boolean;
  sidebarExpanded?: boolean;
}

/**
 * 📦 SidebarHeaderV2
 *
 * Header adaptable:
 * ✅ ERP normal
 * ✅ POS compacto
 */
const SidebarHeaderV2: React.FC<SidebarHeaderV2Props> = ({
  sidebarOpen,
  setSidebarOpen,
  sidebarExpanded = true,
}) => {
  // =====================================================
  // 🎨 Compact mode
  // =====================================================
  const isCompactCollapsed = !sidebarExpanded;

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className={`
        flex items-center
        justify-between
        gap-2

        ${isCompactCollapsed ? 'px-2 py-5' : 'px-6 py-5.5 lg:py-6.5'}
      `}
    >
      {/* 🔹 Logo */}
      <NavLink to="/" className="flex w-full justify-center">
        {isCompactCollapsed ? (
          <img
            className="h-10 w-10 object-contain"
            src={LogoIcon}
            alt="Logo compacto"
          />
        ) : (
          <img className="h-auto w-60" src={Logo} alt="Logo" />
        )}
      </NavLink>

      {/* 🔹 Botón cerrar mobile */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="block lg:hidden"
      >
        <SvgIcon name="arrowleft" />
      </button>
    </div>
  );
};

export default SidebarHeaderV2;
